import { Image, Nav, Navbar, Row } from 'react-bootstrap';
import { FaInfo, FaRegComment, FaSearch, FaUpload } from 'react-icons/fa';
import { GrHelp } from 'react-icons/gr';
import { enableUploads } from './utils';

import React from 'react';

const AppNavbar = () => (
  <Row className="navRow limitedWidth">
    <Image
      src="images/header.jpg"
      fluid
      style={{ width: '100%', height: 'auto' }}
    />

    <Navbar style={{ background: '#e8f2fc' }} expand="md">
      <Navbar.Brand>
        <Nav.Link href="/" style={{ color: 'black' }}>
          {process.env.REACT_APP_TITLE}
        </Nav.Link>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav variant="pills">
          <Nav.Item>
            <Nav.Link href="/">
              <FaSearch /> Documents
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link href="/about">
              <FaInfo /> About
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link href="/how-it-works">
              <GrHelp /> How it works
            </Nav.Link>
          </Nav.Item>

          {process.env.REACT_APP_FEEDBACK_LINK && (
            <Nav.Item>
              <Nav.Link
                href={process.env.REACT_APP_FEEDBACK_LINK}
                id="feedback-link"
              >
                <FaRegComment /> Give feedback
              </Nav.Link>
            </Nav.Item>
          )}

          <Nav.Item>
            {enableUploads && (
              <Nav.Link href="/upload">
                <FaUpload /> Upload
              </Nav.Link>
            )}
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </Row>
);

export default AppNavbar;
